module.exports = __webpack_public_path__ + "static/media/S (65).d9d9ed15.jpg";